import React from 'react';
import { observer } from 'mobx-react-lite';

import { emojiToCdnUrl } from 'widget/utils/emoji';
import { useEmojiStore } from 'widget/hooks/useEmojiStore';

import styles from './EmojiText.module.scss';

const EmojiImg: React.FC<{ emoji: string }> = observer(({ emoji }) => {
  const emojiStore = useEmojiStore();

  const url = emojiToCdnUrl(emoji);
  const status = emojiStore.getStatus(emoji);

  const handleImgError = React.useCallback(
    () => emojiStore.markAsFailed(emoji),
    [emoji, emojiStore]
  );

  if (!url || status === 'failed') {
    return <span className={styles['emoji-fallback']}>{emoji}</span>;
  }

  return (
    <img
      className={styles['emoji-inline']}
      src={url}
      alt={emoji}
      draggable={false}
      onError={handleImgError}
    />
  );
});

export default EmojiImg;
